<script>
  import VueEasyPieChart from 'vue-easy-pie-chart'

  export default{
    name: 'user-stats',
    data () {
      return {}
    },
    computed: {},
    mounted () {
    },
    destroyed () {
    },
    methods: {},
    components: {VueEasyPieChart}
  }
</script>

<template>
  <div class="row row-sm text-center">
    <div class="col-xs-6">
      <div class="panel padder-v item">
        <div class="h1 text-info font-thin h1">9.521</div>
        <span class="text-muted text-xs">Arrematantes cadastrados</span>
        <div class="top text-right w-full">
          <i class="fa fa-caret-up text-warning m-r-sm"></i>
        </div>
      </div>
    </div>
    <div class="col-xs-6">
      <a href="" class="block panel padder-v bg-primary item">
        <span class="text-white font-thin h1 block">930</span>
        <span class="text-muted text-xs">Pessoas online</span>
        <span class="bottom text-right w-full">
          <!--<i class="fa fa-cloud-upload text-muted m-r-sm"></i>-->
        </span>
      </a>
    </div>
    <div class="col-xs-6">
      <a href="" class="block panel padder-v bg-info item">
        <span class="text-white font-thin h1 block">432</span>
        <span class="text-muted text-xs">Cadastros este mês</span>
        <span class="top">
                  <i class="fa fa-caret-up text-warning m-l-sm m-r-sm"></i>
                </span>
      </a>
    </div>
    <div class="col-xs-6">
      <div class="panel padder-v item">
        <div class="font-thin h1">12</div>
        <span class="text-muted text-xs">Cadastros hoje</span>
        <div class="bottom">
          <i class="fa fa-caret-up text-warning m-l-sm m-r-sm"></i>
        </div>
      </div>
    </div>
    <div class="col-xs-12 m-b-md">
      <div class="r bg-light dker item hbox no-border">
        <div class="col w-xs v-middle hidden-md">

          <vue-easy-pie-chart
            :percent="90"
            :line-width="25"
            :track-color="'#e8eff0'"
            :bar-color="'#23b7e5'"
            :scale-color="''"
            :size="50"
            :rotate="45"
            :line-cap="'butt'"
            :animate="2000"
            :font-size="'0'">
          </vue-easy-pie-chart>

        </div>

        <div class="col dk padder-v r-r">
          <div class="text-primary-dk font-thin h2"><a><span>12 atendimentos abertos</span></a></div>
          <span class="text-muted text-xs">87% atendidos hoje, 13% aguardando resposta</span>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// UserStats.vue?84a32190